const MS4s = () => {
  const MS4sData = [
    {
      "agency": "Arapahoe County",
      "total_construction_sites": 38,
      "construction_inspections_count": 503,
      "construction_bmps_count": 0
    },
    {
      "agency": "Douglas County",
      "total_construction_sites": 1047,
      "construction_inspections_count": 5663,
      "construction_bmps_count": 17
    },
    {
      "agency": "City of Aurora",
      "total_construction_sites": 72,
      "construction_inspections_count": 481,
      "construction_bmps_count": 0
    },
    {
      "agency": "SEMSWA (City of Centennial)",
      "total_construction_sites": 46,
      "construction_inspections_count": 490,
      "construction_bmps_count": 4
    },
    {
      "agency": "City of Greenwood Village",
      "total_construction_sites": 1,
      "construction_inspections_count": 30,
      "construction_bmps_count": 30
    },
    {
      "agency": "City of Lone Tree",
      "total_construction_sites": 6,
      "construction_inspections_count": 84,
      "construction_bmps_count": 4
    },
    {
      "agency": "City of Castle Pines",
      "total_construction_sites": 35,
      "construction_inspections_count": 344,
      "construction_bmps_count": 0
    },
    {
      "agency": "Town of Castle Rock",
      "total_construction_sites": 1306,
      "construction_inspections_count": 3622,
      "construction_bmps_count": 10
    },
    {
      "agency": "Town of Parker",
      "total_construction_sites": 130,
      "construction_inspections_count": 2201,
      "construction_bmps_count": 16
    },
    {
      "agency": "CDOT",
      "total_construction_sites": "",
      "construction_inspections_count": "",
      "construction_bmps_count": ""
    }
  ];

   // Declare and configure request overview table
   const MS4sTable = new requestTable({
    container: "#ms4s-table",
    filterEnabled: false,
    tableHeaders: {
      "agency": "Agency",
      "total_construction_sites": "Total Construction Sites",
      "construction_inspections_count": "Construction Inspections",
      "construction_bmps_count": "Permanent BMPs"
    },
    tableActions: [],
    tableData: MS4sData,
  });
  MS4sTable.buildTable();
};
